'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;
// import { Col, Row } from 'react-bootstrap';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _collections = require('redux/modules/collections');

var collectionActions = _interopRequireWildcard(_collections);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _lib = require('helpers/lib');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    collection: state.collections.collection,
    loading: state.collections.loadingDetail,
    loaded: state.collections.loadedDetail,
    categories: state.setup.categories
  };
}, (0, _extends3.default)({}, collectionActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(CollectionDetail, _Component);

  function CollectionDetail() {
    (0, _classCallCheck3.default)(this, CollectionDetail);
    return (0, _possibleConstructorReturn3.default)(this, (CollectionDetail.__proto__ || (0, _getPrototypeOf2.default)(CollectionDetail)).apply(this, arguments));
  }

  (0, _createClass3.default)(CollectionDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getOneByHandle(this.props.params.handle);
    }
  }, {
    key: 'toShopDetail',
    value: function toShopDetail(shop) {
      _reactGa2.default.event({
        category: 'Shop',
        action: 'Clicked Shop Card from Collection',
        label: '' + shop.name
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CollectionPage.scss');
      var collection = this.props.collection;

      var meta = [];
      var imageSeo = collection ? (0, _lib.getUrlImage)(collection.image) : '';
      imageSeo = collection && collection.image ? (0, _lib.getUrlImage)(collection.image) : (0, _lib.getUrlImage)(imageSeo);
      if (imageSeo) {
        meta.push({ property: 'og:image', content: imageSeo });
      }
      var title = collection && collection.name ? collection.name : 'Bộ sưu tập';
      title = collection && collection.title ? collection.title : title;
      if (title) {
        meta.push({ property: 'og:title', content: title });
      }
      var description = collection && collection.description ? collection.description : '';
      if (description) {
        meta.push({
          name: 'description',
          property: 'og:description',
          content: description
        });
      }
      return _react2.default.createElement(
        'div',
        { className: styles.collectionDetail },
        _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.left },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              collection ? collection.name : 'Bộ sưu tập'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.right },
            _react2.default.createElement(
              'div',
              { className: styles.countItem },
              _react2.default.createElement(
                'strong',
                null,
                collection && collection.shops ? collection.shops.length : 0,
                ' '
              ),
              ' ',
              '\u0111\u1ECBa \u0111i\u1EC3m'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.description },
          collection ? collection.description : ''
        ),
        _react2.default.createElement(
          'div',
          { className: styles.listCollection },
          collection && collection.shops && collection.shops.map(function (shop, index) {
            return _react2.default.createElement(_components.SmallCardMobile, { key: index, shop: shop });
          }),
          _react2.default.createElement('div', { className: styles.fakeBottomPadding })
        )
      );
    }
  }]);
  return CollectionDetail;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  loading: _react.PropTypes.bool,
  loaded: _react.PropTypes.bool,
  collection: _react.PropTypes.object,
  getOneByHandle: _react.PropTypes.func.isRequired,
  categories: _react.PropTypes.array
}, _temp)) || _class);
exports.default = CollectionDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Collection/CollectionDetailMobile.js
// module id = 1548
// module chunks = 0